import { useState } from 'react';
import axios from 'axios';
import { Coins, Save } from 'lucide-react';
import { API, money } from '../lib/format';

export function CurrencySettings({ rates, onSaved }) {
  const [form, setForm] = useState({ USD: rates.USD, EUR: rates.EUR });
  const [state, setState] = useState('');
  const submit = async (e) => {
    e.preventDefault(); setState('');
    try { await axios.put(`${API}/settings/rates`, { USD: Number(form.USD), EUR: Number(form.EUR) }); setState('ok'); onSaved(); }
    catch { setState('err'); }
  };
  return <div className="module-grid">
    <div className="panel form-card check-form" data-testid="currency-settings-panel">
      <div className="panel-head"><div><p className="eyebrow">DÖVİZ KURLARI</p><h2>Kur ayarları</h2></div><Coins size={22} color="#087f73" /></div>
      <p className="rate-hint">Gelir/gider ve stok kayıtları TRY, USD veya EUR ile girilebilir. Dashboard ve raporlar tüm tutarları buradaki kurla TRY'ye çevirerek birleştirir.</p>
      <form onSubmit={submit}>
        <div className="form-grid">
          <label>1 USD = ₺<input required type="number" min="0.0001" step="any" value={form.USD} onChange={(e) => setForm({ ...form, USD: e.target.value })} data-testid="rate-usd-input" /></label>
          <label>1 EUR = ₺<input required type="number" min="0.0001" step="any" value={form.EUR} onChange={(e) => setForm({ ...form, EUR: e.target.value })} data-testid="rate-eur-input" /></label>
        </div>
        {state === 'ok' && <p className="success-text" data-testid="rate-saved-message">Kurlar güncellendi, dashboard yeniden hesaplandı.</p>}
        {state === 'err' && <p className="error-text" data-testid="rate-error-message">Kur kaydedilemedi. Pozitif bir değer girin.</p>}
        <button className="primary" data-testid="save-rates-button"><Save size={15} /> Kurları kaydet</button>
      </form>
    </div>
    <div className="panel table-panel">
      <div className="panel-head"><div><p className="eyebrow">ÖZET</p><h2>Aktif kurlar</h2></div></div>
      <div className="rate-card">
        <div className="rate-box" data-testid="rate-box-try"><span>TRY</span><b>₺1,00</b></div>
        <div className="rate-box" data-testid="rate-box-usd"><span>USD</span><b>{money(rates.USD, 'TRY', 2)}</b></div>
        <div className="rate-box" data-testid="rate-box-eur"><span>EUR</span><b>{money(rates.EUR, 'TRY', 2)}</b></div>
      </div>
      <p className="rate-hint">Örnek: 1.000 USD gelir → {money(1000 * rates.USD)} · 500 EUR gider → {money(500 * rates.EUR)}</p>
    </div>
  </div>;
}
